module.exports = __webpack_public_path__ + "img/iiko-48.0c4a05a1.jpg";